import { handleActions } from "redux-actions";

import state from "./state";
export type NotificationState = typeof state;

const notifications = handleActions({}, { data: [] });

export { notifications };
